import { configureStore, ThunkAction, Action, getDefaultMiddleware } from '@reduxjs/toolkit';
import { all } from 'redux-saga/effects';
import groupReducer from './Group/reducer';
import itinerariesReducer from './Itineraries/reducer';
import pageReducer from '../common/Page/reducer';
import GroupSaga from '@Redux/detail/Group/saga';
import ItinerariesSaga from '@Redux/detail/Itineraries/saga';
import createSagaMiddleware from 'redux-saga';

function* rootSaga() {
    yield all([...GroupSaga, ...ItinerariesSaga]);
}

const sagaMiddleware = createSagaMiddleware();
export const store = configureStore({
    reducer: {
        groupReducer,
        itinerariesReducer,
        pageReducer,
    },
    middleware: [...getDefaultMiddleware(), sagaMiddleware],
});
sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
